<template>
    <c-dialog ref="dialog" width="450" height="350" @resolve="editHandle">
        <c-form ref="form" unit-width="100%">
            <c-form-item label="商户代码">
                <c-input type="number" name="saas_id" disabled></c-input>
            </c-form-item>
            <c-form-item label="商户名称">
                <c-input name="saas_full_name" disabled></c-input>
            </c-form-item>
            <c-form-item label="开通竞价堂">
                <c-radio-group name="is_open_jldhs" v-model="is_open_jldhs" :options="isOpenJldhsOptions" :clear="false">
                </c-radio-group>
            </c-form-item>
            <c-form-item label="竞价堂账号" :required="is_open_jldhs == 1" tip="请输入当前商户关联的竞价堂账号（一个账号只允许关联一个商户）">
                <c-input name="jldhs_account"></c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
export default {
    name:'jldhsAccountEdit',
    data() {
        return {
            is_open_jldhs:0,
            isOpenJldhsOptions:[
                {
                    name: '开通',
                    value: 1,
                    color: 'green'
                },
                {
                    name: '关闭',
                    value: 0,
                    color: 'gray'
                }
            ]
        }
    },
    computed: {
    },

    methods: {
        /*********打开编辑框，初始化**********/
        open(data) {
            this.$refs.form.clear();
            if (data) {
                this.$refs.form.set(data);
            }
            //填充form表单
            this.$refs.dialog.open({
                title: '配置竞价堂账号'
            });
        },

        /*******创建、编辑提交处理方法********/
        editHandle(stop, next) {
            stop();
            this.$refs.form.submit({
                url: '/sys_saas/edit/jldhs_account',
                rule: {
                    is_open_jldhs: '请选择是否开通商户竞价堂功能',
                    jldhs_account: [{
                        type: 'empty',
                        message: '请输入竞价堂账号信息',
                        skip: () => {
                            return this.is_open_jldhs == 0;
                        }
                    }]
                },
                dataFormatter: data => {
                    return data;
                },
                success: (data, res) => {
                    next();
                    this.$message({
                        message: '操作成功',  // 提示内容,
                        type: 'success'
                    });
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>